import { format, formatDistanceToNowStrict, isValid } from 'date-fns'
import type { ApiKeyEnvironment } from './apiKeys.types'

export function secretPrefix(environment: ApiKeyEnvironment): string {
  return environment === 'production' ? 'sk_live_' : 'sk_test_'
}

/** `sk_live_a1b2c3…p6` → `sk_live_a1b2••••3f9c` */
export function maskSecret(secret: string): string {
  const match = /^(sk_(?:live|test)_)(.*)$/.exec(secret)
  const prefix = match?.[1] ?? ''
  const body = match?.[2] ?? secret
  if (body.length <= 8) return `${prefix}${body}`
  return `${prefix}${body.slice(0, 4)}••••${body.slice(-4)}`
}

/** `Jun 12, 2026` */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  return isValid(date) ? format(date, 'MMM dd, yyyy') : '—'
}

/** `3 minutes ago`; `—` when never used. */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  return isValid(date) ? formatDistanceToNowStrict(date, { addSuffix: true }) : '—'
}

/** curl snippet shown after creation; the secret is masked unless `revealSecret`. */
export function curlSnippet(secret: string, revealSecret = false): string {
  const value = revealSecret
    ? secret
    : `${secretPrefix(secret.startsWith('sk_test_') ? 'sandbox' : 'production')}••••`
  return `curl https://api.saiva.com/api/v1/patients \\\n  -H "x-api-key: ${value}"`
}

/** `patients, risk…` style preview of the first distinct scope domains. */
export function scopePreview(scopes: string[], max = 2): string {
  const domains: string[] = []
  for (const scope of scopes) {
    const domain = scope.split('.')[0]
    if (!domains.includes(domain)) domains.push(domain)
  }
  const shown = domains.slice(0, max).join(', ')
  return domains.length > max ? `${shown}…` : shown
}
